module.exports = __webpack_public_path__ + "static/img/promptpay.9c6899ad.png";